module.exports = __webpack_public_path__ + "static/media/dollar_coin.22d0cc90.png";